import { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import { OUTLET, NETT_AMOUNT, REVIEW, STATUS } from "constants/commonTableColumn";

export const RETRO_CLAIM_COLUMN_DATA: Array<ColumnHeaderRowType> = [
	{
		title: "Generated Date & Time",
		dataIndex: "receipt_datetime",
		align: "left",
		width: "10%"
	},
	{
		title: "Reviewed Date & Time",
		dataIndex: "verified_on",
		align: "left",
		width: "10%"
	},
	{
		title: "Agent ID",
		dataIndex: "agentId",
		align: "left",
		width: "8%"
	},
	{
		...OUTLET,
		dataIndex: "outlet",
		width: "20%"
	},
	{
		title: "Source",
		dataIndex: "source",
		align: "left",
		width: "8%"
	},
	{
		title: "Tier",
		dataIndex: "tier",
		align: "left",
		width: "6%"
	},
	{
		title: "Purchase amount",
		dataIndex: "purchaseAmount",
		align: "left",
		width: "8%"
	},
	{
		...STATUS,
		dataIndex: "status"
	},
	{
		...NETT_AMOUNT,
		dataIndex: "netAmount"
	},
	REVIEW
];
